import React, { FC } from 'react';
import { useFormikContext } from 'formik';
import classNames from 'classnames';

import { FormInput } from 'Shared/components';
import { FormValuesType } from 'QuoteApp/services/endpoints/GetDetails';
import { GetVehicleByExactVinResponseType } from 'QuoteApp/components/VehiclesList/VehicleSelection';

import styles from './styles.module.css';

type VehicleMultiselectType = {
  vehicleId: string;
  data: GetVehicleByExactVinResponseType[];
  layout?: 'columns';
  hasError?: boolean;
  onChange?: () => void;
};

export const VehicleMultiselect: FC<VehicleMultiselectType> = ({
  vehicleId,
  data,
  layout,
  hasError,
  onChange,
}) => {
  const { values, setValues } = useFormikContext<FormValuesType>();

  if (!data.length) {
    return null;
  }

  const selectedVehicle = values.vehicles[vehicleId];

  return (
    <div className={styles.multiselectContainer}>
      <div className={styles.multiselectHeading}>Multiple VIN Matches</div>
      <div className={styles.multiselectLabel}>
        Please select the correct vehicle below
      </div>
      <div
        className={classNames({
          [styles.multiselectColumns]: layout === 'columns',
        })}
      >
        {data.map((vehicle) => (
          <FormInput
            key={vehicle.id}
            className={styles.multiselectRadio}
            indicatorClassName={classNames({
              [styles.indicatorHasError]: hasError,
            })}
            name="vehicle-multiselect"
            variant="radio"
            data-testid={`vehicle-multiselect-${vehicle.id}`}
            label={
              <>
                <div className={styles.multiselectHeading}>
                  {`${vehicle.year} ${vehicle.make} ${vehicle.model}`}
                </div>
                <div className={styles.multiselectLabel}>
                  {`Body Style: ${vehicle.bodyStyle}`}
                </div>
              </>
            }
            value={vehicle.id}
            checked={vehicle.id === selectedVehicle?.vehicleServicesId}
            onChecked={() => {
              setValues({
                ...values,
                vehicles: {
                  ...values.vehicles,
                  [vehicleId]: {
                    ...values.vehicles[vehicleId],
                    year: vehicle.year.toString(),
                    make: vehicle.make,
                    model: vehicle.model,
                    bodyStyle: vehicle.bodyStyle,
                    vehicleServicesId: vehicle.id,
                    partialVin: vehicle.partialVin || '',
                  },
                },
              });
              onChange?.();
            }}
          />
        ))}
      </div>
    </div>
  );
};
